<template>
  <div>
    <b-button
      class="d-flex ml-auto"
      v-b-toggle.collapse-1
      variant="link"
    >
      <AppSvgIcon :class="[isFiltered ? 'text-secondary' : 'text-dark']" width="2rem" height="2rem" :icon="$getConst.svgIcons.filter_icon"/>
    </b-button>
    <b-collapse id="collapse-1" class="my-2">
      <b-row>
        <b-col md="6" sm="12">
          <b-form-group label="status" label-for="status-input">
            <multiselect
              v-model="newStatus"
              :multiple="true"
              :close-on-select="false"
              :options="this.isWorker() ? $getConst.timesheetsStatusWorkerAsArray() : $getConst.timesheetsStatusApproverAsArray()"
              :show-labels="false"
              :searchable="true"
              :allow-empty="false"
              :disabled ="statusSelectDisabled"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="date range" label-for="status-input">
            <date-picker
              id="status-input"
              mode='range'
              v-model='newDate'
              :model-config="modelConfig"
              is-range
              @input="emitData"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <b-row>
                  <b-col>
                    <b-form-input
                      size="lg"
                      placeholder="DD/MM/YYYY"
                      :value="inputValue.start"
                      v-on="inputEvents.start"
                      class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                    />
                  </b-col>
                  <b-col>
                    <b-form-input
                      size="lg"
                      placeholder="DD/MM/YYYY"
                      :value="inputValue.end"
                      v-on="inputEvents.end"
                      class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                    />
                  </b-col>
                </b-row>
              </template>
            </date-picker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>

  </div>
</template>

<script>
  import {debounce} from "lodash";
  import {DatePicker} from 'v-calendar'

  export default {
    name: "TimesheetsFilters",
    components: {DatePicker},
    props: {
      status: {
        type: Array,
        default: function () {
          return [];
        }
      },
      date: {
        type: Object,
        default: function () {
          return {start: null, end: null}
        }
      },
      statusSelectDisabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        newStatus: this.status,
        newDate: this.date,
        modelConfig: {
          type: 'string',
          mask: 'DD/MM/YYYY',
        },
      }
    },
    computed: {
      isFiltered() {
        return !!((this.status.length) || this.date.start || this.date.end);
      }
    },
    created() {
      this.debounceInput = debounce(this.emitData, 1000);
    },
    methods: {
      emitData() {
        this.$emit("Filter", {status: this.newStatus, fromDate: this.newDate.start, endDate: this.newDate.end})
      },
    },
    watch: {
      newStatus() {
        this.debounceInput();
      },
    }
  }
</script>

<style scoped>

</style>
